<div class="ticket" [class]="status">
  <div class="d-flex justify-content-between">
    <div>
      @for (ticket of [ticket1, ticket2, ticket3]; track $index) {
        <span class="ticket-flight_number">LA{{ ticket?.flightNumber }}</span>
      }
    </div>
    <div class="d-flex gap-1">
      <div>
        <img src="assets/images/airplane_boarding.svg" alt="Avião Partindo"/>
      </div>
      <div>
        @for (ticket of [ticket1, ticket2, ticket3]; track $index) {
          <span class="ticket-boarding_date">{{ ticket?.departureDateLt | dateFormat: 'DD/MM/YYYY HH:mm' }}</span>
        }
      </div>
    </div>
  </div>

  @if (isActive) {
    <div class="d-flex justify-content-end">
      <app-seat-availability [items]="[ticket1!, ticket2!, ticket3!]"></app-seat-availability>
    </div>
  }

  <div class="d-flex justify-content-between">
    <span class="ticket-origin_destiny">
      {{ ticket1?.departure }}/{{ ticket1?.arrival }}/{{ ticket2?.arrival }}/{{ ticket3?.arrival }}
    </span>
    <div class="d-flex gap-1">
      <div>
        <img src="assets/images/airplane_arrival.svg" alt="Avião Chegando"/>
      </div>
      <div>
        @for (ticket of [ticket1, ticket2, ticket3]; track $index) {
          <span class="ticket-arrival_date">{{ ticket?.arrivalDateLt | dateFormat: 'DD/MM/YYYY HH:mm' }}</span>
        }
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between">
    <div>
      @for (ticket of [ticket1]; track $index) {
        <div class="d-flex gap-1">
          <div>
            <span class="ticket_number">{{ ticket?.ticketNumber }}</span>
          </div>
          <div class="copy-text" (click)="ticket && copyText(ticket.ticketNumber)" #tooltip="matTooltip" matTooltip="Copiar">
            <img src="assets/images/copy.svg" alt="Copiar Texto">
          </div>
        </div>
      }
    </div>

    @if (isActive) {
      <div class="d-flex gap-1">
        <a class="web-checking" href="https://www.latamairlines.com/br/pt/check-in"
          target="_blank" rel="noopener noreferrer">
          WEB CHECKING
        </a>
      </div>
    }
  </div>

  <div class="d-flex justify-content-between">
    <div class="d-flex gap-1">
      @for (ticket of [ticket1]; track $index) {
        <span class="ticket-reservation_code">{{ ticket?.pnrCode }}</span>
        <div class="copy-text" (click)="ticket && copyText(ticket.pnrCode)" #tooltip="matTooltip" matTooltip="Copiar">
          <img src="assets/images/copy.svg" alt="Copiar Texto">
        </div>
      }
    </div>
    @if (isActive) {
      <button class="btn-cancel" (click)="cancelTicket()">Cancelar</button>
    }
  </div>
</div>
